import React from "react"

export default ({ dir = 'rtl', icon, placeholder, onChange, value, onKeyDown, onClick, className, disabled, type, inputStyle, onFocus, required = false }) => {
  return (
    <label className={"radius-4 " + className} {...(disabled ? { style: { opacity: .45 } } : {})}>
      <div className="flexed align-c h-100">
        <div className="px-8 h-100 inline-flexed align-c text-shadow">
          <span className="font-12">{placeholder}</span>
          {required && <div className="required">*</div>}
        </div>
        <div className="flex-1 h-100">
          <input dir={dir} onFocus={onFocus} disabled={disabled} type={type || "search"} onChange={e => {
            onChange(e.target.value)
          }} value={value}
            style={{ ...inputStyle }}
            onKeyDown={e => onKeyDown && onKeyDown(e)}
            className="bd-none bg-none dropdown py-8 px-8 font-14 iran-sans-medium iran-sans w-100 text-center h-100 text-shadow" />
        </div>
        {icon && <button className="bd-none bg-none icon-button mx-16 p-0" onClick={(e) => onClick && onClick(e)}>
          <img className="icon-sm valign-mid button" src={icon} alt="" />
        </button>}
      </div>
    </label>
  )
}
